import React, { useState } from 'react';
import { Slider } from '../Slider';
import { Panel, PanelTheme } from '../Panel';
import { DemoPage } from './common/DemoLayout';

export const SliderDemo: React.FC = () => {
    // Example: full range is 0 to 100, reserved area from 0 to 20.
    const max = 100;
    const reserved = 70;
    // Initial value, must be >= reserved
    const [value, setValue] = useState(70);

    return (
        <div style={{ maxWidth: '500px' }}>
            <DemoPage title='Slider :'>
                <Panel
                    theme={PanelTheme.White}
                    width='88%'
                >
                    <Slider
                        value={value}
                        maxAmount={max}
                        reservedAmount={reserved}
                        onValueChanged={setValue}
                    />
                </Panel>
            </DemoPage>
        </div>
    );
};
